import React, { useState, useEffect } from "react";
import imgit2 from "./assets/kreative-leinwände/image2.jpeg";

import styles from "./Newsbg.module.css";
import { Link } from "react-router-dom";

import newsData from "./NewsData";
import { getImages } from "./getImages";

const NewsbgList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const blogData = newsData
    .map((item) => ({
      ...item,
images: getImages(item.slug),
      description: item.content?.[0] || "",
      link: `/news/${item.slug}`,
    }))
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const filteredData = blogData.filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // RESET IMAGE INDEX (SAFE)
  useEffect(() => {
    const indexes = {};

    filteredData.forEach((_, i) => {
      indexes[i] = 0;
    });

    setCurrentImageIndex(indexes);
  }, [searchTerm, filteredData.length]);

  const nextImage = (index) => {
    const item = filteredData[index];
    if (!item?.images?.length) return;

    setCurrentImageIndex((prev) => ({
      ...prev,
      [index]: (prev[index] ?? 0 + 1) % item.images.length,
    }));
  };

  const prevImage = (index) => {
    const item = filteredData[index];
    if (!item?.images?.length) return;

    setCurrentImageIndex((prev) => ({
      ...prev,
      [index]:
        ((prev[index] ?? 0) - 1 + item.images.length) %
        item.images.length,
    }));
  };

  return (
    <>
      {/* HERO */}
      <div
        className={styles.hero}
        style={{ backgroundImage: `url(${imgit2})` }}
      />

      <div className="wrapper wrapperContent">
        {/* HEADER */}
        <div className={styles.header}>
          <h1>NEWS</h1>
          <h2>Aktuelles aus der IKS</h2>
        </div>

        {/* SEARCH */}
        <div className={styles.searchContainer}>
          <input
            type="text"
            placeholder="Suche nach Titel..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
        </div>

        {/* LIST */}
        <div className={styles.listContainer}>
          {filteredData.length > 0 ? (
            filteredData.map((item, i) => (
              <Link
                to={item.link}
                key={item.slug}
                className={styles.cardLink}
              >
                <div className={styles.card}>
                  {/* IMAGE */}
                  <div className={styles.imageContainer}>
                    {item.images?.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={item.title}
                        loading="lazy"
                        className={
                          idx === (currentImageIndex[i] ?? 0)
                            ? styles.active
                            : ""
                        }
                      />
                    ))}
                  </div>

                  {/* DATE */}
                  <span className={styles.dateBadge}>
                    {new Date(item.date).toLocaleDateString("de-DE", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>

                  {/* CONTENT */}
                  <div className={styles.content}>
                    <h2 className={styles.title}>{item.title}</h2>

                    <p className={styles.description}>
                      {item.description.length > 150
                        ? item.description.slice(0, 150) + "..."
                        : item.description}
                    </p>

                    <span className={styles.readMore}>
                      Weiterlesen →
                    </span>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <p className={styles.noResult}>
              Keine Beiträge gefunden.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default NewsbgList;